import store from '../../../store/sellsyaccountmanager/customer';

export default {
    created() {
        // Init store
        this.$store.registerModule('customer', store);
    },
}